import React from 'react';
import SelectedList from '../comonents/SelectedList';

const SelectedPage = () => {
    return (
        <div>
            <SelectedList/>
        </div>
    );
};

export default SelectedPage;